import { useCampaignVersionsQuery } from '@/layouts/campaigns/api/useCampaignVersionsQuery'
import { InputDateRange, cn } from '@dashboard/ui'
import { useParams } from 'react-router-dom'
import { SelectMulti } from '@/ui'

import { useNodeAnalyticsStore } from '@/layouts/campaigns/useNodeAnalyticsStore'
import { useContext } from 'react'
import { CampaignContext, ICampaignContext } from '@/expr/Context'

interface NodeAnalyticsFiltersProps {
  className?: string
}

export const NodeAnalyticsFilters = ({ className }: NodeAnalyticsFiltersProps) => {
  const context = useContext(CampaignContext) as ICampaignContext
  const { companyId, gameId, eventId } = useParams() as {
    companyId: string
    gameId: string
    eventId: string
    campaignVersionId: string
  }

  const { data: items = [] } = useCampaignVersionsQuery(companyId, gameId, eventId, {
    offset: 0,
    limit: 100,
  })

  const { presets, setSelectedDateFilter, selectedDateFilter, versions, setVersions } = useNodeAnalyticsStore()

  return (
    <div
      className={cn(
        ' flex items-center rounded-b border-b border-l border-b-border-primary bg-fg-primary p-2',
        className,
      )}
    >
      <div>
        {selectedDateFilter && (
          <InputDateRange
            clearable={false}
            presets={presets}
            value={selectedDateFilter.range}
            onChange={v => {
              setSelectedDateFilter({
                ...selectedDateFilter,
                range: v!,
              })
            }}
          />
        )}
      </div>
      <div className="min-w-[100px] pl-2">
        <SelectMulti
          items={[
            context.campaign && { children: context.campaign.version, value: context.campaign.version },
            ...items.map(item => ({
              children: item.version,
              value: item.version,
            })),
          ].filter(Boolean)}
          value={versions}
          onChange={v => {
            setVersions(v as string[])
          }}
        />
      </div>
    </div>
  )
}
